export default __webpack_public_path__ + "static/media/icon_glasses.3c79d8e2.png";